import { TableColumnType } from 'src/types/table';

export const allColumns: TableColumnType[] = [
    {
        key: 'ID',
        label: 'id',
        type: 'number',
        defaultShow: true,
    },
    {
        key: 'DCIX_PROVIDER_ID',
        label: 'idDcix',
        type: 'number',
        defaultShow: true,
    },
    {
        key: 'VIRTUAL_ESHOP_PARENT',
        label: 'providerDetail.virtualEshopParent',
        defaultShow: false,
    },
    {
        key: 'COMPANY_NAME',
        label: 'eshopName',
        defaultShow: true,
    },
    {
        key: 'BUSINESS_NAME',
        label: 'businessName',
        defaultShow: false,
    },
    {
        key: 'WEBSITE',
        label: 'website',
        defaultShow: true,
    },
    {
        key: 'SYSTEM',
        label: 'system',
        defaultShow: true,
    },
    {
        key: 'ESHOP_KEY',
        label: 'providerDetail.eshopKey',
        defaultShow: false,
    },
    {
        key: 'STATUS',
        label: 'providerDetail.status',
        type: 'select',
        selectOption: 'providerStatusCodes',
        defaultShow: true,
        optionStyleFce: true,
        customRender: true,
    },
    {
        key: 'PLANNED_LAUNCH',
        label: 'providerDetail.plannedLaunch',
        type: 'date',
        defaultShow: false,
    },
    {
        key: 'ACTUAL_LAUNCH',
        label: 'providerDetail.actualLaunch',
        type: 'dateTime',
        defaultShow: false,
    },
    {
        key: 'PLANNED_OFFBOARDING',
        label: 'providerDetail.plannedOffboarding',
        type: 'date',
        defaultShow: false,
    },
    {
        key: 'ACTUAL_OFFBOARDING',
        label: 'providerDetail.actualOffboarding',
        type: 'dateTime',
        defaultShow: false,
    },
    {
        key: 'ACTIVE',
        label: 'providerDetail.shownInMys',
        type: 'select',
        selectOption: 'boolNumberCodes',
        defaultShow: true,
    },
    {
        key: 'SHOPTET_STOCK_RATIO',
        label: 'providerDetail.shoptetStockRatio',
        type: 'number',
        defaultShow: false,
    },
    {
        key: 'ALLOWED_ORDER_PRODUCTS_EDIT',
        label: 'providerDetail.allowedOrderProductsEdit',
        type: 'select',
        selectOption: 'boolNumberCodes',
        defaultShow: false,
    },
    {
        key: 'PRINT_RETURN_LABEL',
        label: 'providerDetail.enableReturnLabels',
        type: 'select',
        selectOption: 'boolNumberCodes',
        defaultShow: false,
    },
    {
        key: 'ENABLE_RETURN_LABELS',
        label: 'providerDetail.printReturnLabel',
        type: 'select',
        selectOption: 'boolNumberCodes',
        defaultShow: false,
    },
    {
        key: 'UNDER_SANCTION_ENABLED',
        label: 'providerDetail.underSanctionEnabled',
        type: 'select',
        selectOption: 'boolNumberCodes',
        defaultShow: false,
    },
    {
        key: 'ALLOW_DISABLE_SHIPPING_REORDER',
        label: 'providerDetail.allowDisableShippingReorder',
        type: 'select',
        selectOption: 'boolNumberCodes',
        defaultShow: false,
    },
    {
        key: 'CUSTOMS_WAREHOUSE_ENABLED',
        label: 'providerDetail.customsWarehouseEnabled',
        type: 'select',
        selectOption: 'boolNumberCodes',
        defaultShow: false,
    },
    {
        key: 'DCIX_EXPORT_PERSONAL_DATA',
        label: 'providerDetail.dcixExportPersonalData',
        type: 'select',
        selectOption: 'boolNumberCodes',
        defaultShow: false,
    },
    {
        key: 'ALLOW_ORDER_PRODUCT_DETAIL',
        label: 'providerDetail.orderProductDetail',
        type: 'select',
        selectOption: 'boolNumberCodes',
        defaultShow: false,
    },
    {
        key: 'DEFAULT_PRINT_FILES',
        label: 'providerDetail.printFiles',
        type: 'select',
        selectOption: 'boolNumberCodes',
        defaultShow: false,
    },
    {
        key: 'SALES_REPRESENTATIVE',
        label: 'providerDetail.salesRepresentative',
        defaultShow: true,
        type: 'select',
        selectOption: 'salesRepresentativeCodes',
    },
    {
        key: 'KEY_ACCOUNT_MANAGER',
        label: 'providerDetail.keyAccountManager',
        defaultShow: true,
        type: 'select',
        selectOption: 'keyAccountManagerCodes',
    },
    {
        key: 'SLA_ALZA_SHIPPING',
        label: 'providerDetail.slaAlzaShipping',
        defaultShow: true,
    },
    {
        key: 'RECEIVING_POSTPONE_HOURS',
        label: 'providerDetail.receivingPostponeHours',
        type: 'number',
        defaultShow: true,
    },
    {
        key: 'B2C_SLA',
        label: 'providerDetail.b2cSla',
        defaultShow: true,
    },
    {
        key: 'B2B_SLA',
        label: 'providerDetail.b2bSla',
        defaultShow: true,
    },
    {
        key: 'B2B_D0',
        label: 'providerDetail.b2bD0',
        type: 'number',
        defaultShow: true,
    },
    {
        key: 'B2B_D1',
        label: 'providerDetail.b2bD1',
        type: 'number',
        defaultShow: true,
    },
    {
        key: 'B2B_D2',
        label: 'providerDetail.b2bD2',
        type: 'number',
        defaultShow: true,
    },
    {
        key: 'B2B_D3',
        label: 'providerDetail.b2bD3',
        type: 'number',
        defaultShow: true,
    },
    {
        key: 'CONTACT_PERSON',
        label: 'providerDetail.contactPerson',
        defaultShow: true,
    },
    {
        key: 'PROVIDER_COMPANY_PHONE',
        label: 'providerDetail.phone',
        defaultShow: true,
    },
    {
        key: 'PROVIDER_EMAIL',
        label: 'email',
        defaultShow: true,
    },
    {
        key: 'BILLING_EMAIL',
        label: 'providerDetail.billingEmail',
        defaultShow: true,
        customRender: true,
    },
    {
        key: 'PROVIDER_STREET',
        label: 'providerDetail.street',
        defaultShow: false,
    },
    {
        key: 'PROVIDER_CITY',
        label: 'providerDetail.city',
        defaultShow: false,
    },
    {
        key: 'PROVIDER_POST_CODE',
        label: 'providerDetail.postCode',
        defaultShow: false,
    },
    {
        key: 'PROVIDER_STATE',
        label: 'providerDetail.state',
        defaultShow: false,
    },
    {
        key: 'PROVIDER_BILLING_STREET',
        label: 'providerDetail.billingStreet',
        defaultShow: false,
    },
    {
        key: 'PROVIDER_BILLING_CITY',
        label: 'providerDetail.billingCity',
        defaultShow: false,
    },
    {
        key: 'BILLING_POST_CODE',
        label: 'providerDetail.billingPostCode',
        defaultShow: false,
    },
    {
        key: 'PROVIDER_BILLING_STATE',
        label: 'providerDetail.billingState',
        defaultShow: false,
    },
    {
        key: 'PROVIDER_COMPANY_ID',
        label: 'providerDetail.companyId',
        defaultShow: false,
    },
    {
        key: 'PROVIDER_TAX_ID',
        label: 'providerDetail.taxId',
        defaultShow: false,
    },
    {
        key: 'EORI',
        label: 'providerDetail.eori',
        defaultShow: false,
    },
    {
        key: 'GLN',
        label: 'providerDetail.GLN',
        defaultShow: false,
    },
    {
        key: 'CLIENT_TYPE',
        label: 'providerDetail.clientType',
        type: 'select',
        selectOption: 'clientTypeCodes',
        defaultShow: false,
    },
    {
        key: 'BUSINESS_FIELD',
        label: 'providerDetail.businessField',
        type: 'select',
        selectOption: 'businessFieldCodes',
        defaultShow: false,
    },
    {
        key: 'CONTRACT_SIGNING_DATE',
        label: 'providerDetail.contractSigningDate',
        type: 'date',
        defaultShow: false,
    },
    {
        key: 'CONTRACT_TERM',
        label: 'providerDetail.contractTerm',
        type: 'select',
        selectOption: 'contractTermCodes',
        defaultShow: false,
    },
    {
        key: 'CONTRACT_END_DATE',
        label: 'providerDetail.contractEndDate',
        type: 'date',
        defaultShow: false,
    },
    {
        key: 'INVOICE_DUE_DAYS',
        label: 'providerDetail.invoiceDueDays',
        type: 'number',
        defaultShow: false,
    },
    {
        key: 'NOTICE_PERIOD_MONTHS',
        label: 'providerDetail.noticePeriodMonths',
        type: 'number',
        defaultShow: false,
    },
];

export const waitingColumns: TableColumnType[] = [
    {
        key: 'ID',
        label: 'id',
        type: 'number',
    },
    {
        key: 'PROVIDER_NAME',
        label: 'eshopName',
    },
];
